<template>
  <div>
    <v-tabs class="tabs">
      <v-tab
        class="tabs_tab"
        exact-active-class="tabs_tab_active"
        v-for="tab in tabs"
        :key="tab.value"
        link
        :to="tab.to"
      >
        {{ tab.value }}</v-tab
      >
    </v-tabs>
    <slot />
  </div>
</template>
<script>
export default {
  name: "Tabs",
  props: {
    tabs: { required: true, type: Array },
  },
};
</script>
